export default __webpack_public_path__ + "static/media/doomfist-punch.05702c67.mp3";